import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getTeamPageData } from './api';
import type { TeamPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: TeamPageDataContext,
	Provider: TeamPageDataContextProvider,
	useContext: useTeamPageData,
	useAsyncData: useTeamPageDataFromApi,
	prefetchAsyncData: prefetchTeamPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'TeamPageDataContext',
	dataProperty: 'pageData',
	getData: getTeamPageData,
	errorHandler: pageDataErrorHandler<TeamPageDataErrorCode>(),
});
